import { render, staticRenderFns } from "./Pcmso.vue?vue&type=template&id=13b61a70&scoped=true&"
import script from "./Pcmso.vue?vue&type=script&lang=js&"
export * from "./Pcmso.vue?vue&type=script&lang=js&"
import style0 from "./Pcmso.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Pcmso.vue?vue&type=style&index=1&id=13b61a70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b61a70",
  null
  
)

export default component.exports